import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faCheckCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import './forgotpassword.css';

const apiUrl = process.env.REACT_APP_API_URL;

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setErrorMessage('');
    setSuccessMessage('');

    try {
      const response = await fetch(`${apiUrl}/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok) {
        setSuccessMessage('Un email cu instrucțiuni de resetare a parolei a fost trimis la adresa specificată.');
        setEmail('');
      } else {
        setErrorMessage(data.message || 'A apărut o eroare. Te rugăm să încerci din nou.');
      }
    } catch (error) {
      setErrorMessage('A apărut o eroare la trimiterea email-ului. Te rugăm să încerci din nou.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="forgot-password-container">
      <div className="forgot-password-card">
        <h2 className="forgot-password-title">Resetare parola</h2>
        <p className="forgot-password-description">
          Introdu adresa de email asociata contului tau si vei primi un link pentru resetarea parolei.
        </p>

        {successMessage && (
          <div className="message-box success-message-box">
            <FontAwesomeIcon icon={faCheckCircle} className="message-icon" />
            {successMessage}
          </div>
        )}

        {errorMessage && (
          <div className="message-box error-message-box">
            <FontAwesomeIcon icon={faTimesCircle} className="message-icon" />
            {errorMessage}
          </div>
        )}

        <form className="forgot-password-form" onSubmit={handleSubmit}>
          <div className="input-group-reg">
            <FontAwesomeIcon icon={faEnvelope} className="input-icon-reg" />
            <input
              type="email"
              placeholder="Adresa de email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input-reg with-icon"
              required
            />
          </div>

          <button type="submit" className="input-reg-submit" disabled={isLoading}>
            {isLoading ? 'Se trimite...' : 'Trimite link de resetare'}
          </button>
        </form>

        <div className="forgot-password-links">
          <Link to="/login" className="back-to-login">
            ← Inapoi la autentificare
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
